import { Routes, Route } from 'react-router-dom';
import { Router } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { UPLOAD_COMPLIANCE_REGISTRY_DOCUMENTS } from 'domain/shared/compliance';
import { COMPLIANCE_REGISTRY_PATH } from './router';
import ComplianceRegistryListPage from './List/ComplianceRegistryListPage';
import { ComplianceDocumentContext } from 'domain/shared/compliance';
import { GlobalProtectedRoute } from 'framework/authorization';
import ComplianceDocumentVersionEditorPage from './documentVersionEditor/editor/ComplianceDocumentVersionEditorPage';
import ComplianceDocumentVersionFinalizePage from './documentVersionEditor/diff/ComplianceDocumentVersionFinalizePage';

const ComplianceRegistryRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();

  return (
    <Routes>
      <Route
        index
        element={
          <GlobalProtectedRoute globalPermissionToCheck={[UPLOAD_COMPLIANCE_REGISTRY_DOCUMENTS]}>
            <ComplianceDocumentContext>
              <ComplianceRegistryListPage />
            </ComplianceDocumentContext>
          </GlobalProtectedRoute>
        }
      />

      <Route
        path="md-editor"
        element={
          <GlobalProtectedRoute globalPermissionToCheck={[UPLOAD_COMPLIANCE_REGISTRY_DOCUMENTS]}>
            <ComplianceDocumentContext>
              <ComplianceDocumentVersionEditorPage />
            </ComplianceDocumentContext>
          </GlobalProtectedRoute>
        }
      />

      <Route
        path="md-editor/finalize"
        element={
          <GlobalProtectedRoute globalPermissionToCheck={[UPLOAD_COMPLIANCE_REGISTRY_DOCUMENTS]}>
            <ComplianceDocumentContext>
              <ComplianceDocumentVersionFinalizePage />
            </ComplianceDocumentContext>
          </GlobalProtectedRoute>
        }
      />
      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

ComplianceRegistryRouter.getRouterPath = () => `${COMPLIANCE_REGISTRY_PATH}/*`;

export default ComplianceRegistryRouter;
